import constants from '@atlas/tool/box/constants';
import type { TUploadedAttachment } from '@atlas/tool/box/file/types';
import type { TFileStackUploadedFile } from '@atlas/tool/box/file/filestack';

export default function fileResponseToUploadedAttachment(fileResponse: TFileStackUploadedFile): TUploadedAttachment {
    const { container, filename: name, handle, key, size } = fileResponse;
    // Generally, we upload to atlas-prod-uploads bucket which is publicly accessible from files.atlas.so
    // It is mostly safe to remap the hostname directly. Keeping fallback in case the bucket changes
    const urlEncodedKey = sanitizeURI(encodeURIComponent(key));
    const url =
        container === PROD_CONTAINER
            ? `${constants.FILE_UPLOADS_CDN}/${urlEncodedKey}`
            : `https://${container}.s3.amazonaws.com/${urlEncodedKey}`;

    return { name, handle, size, url };
}

const PROD_CONTAINER = 'atlas-prod-uploads' as const;

function sanitizeURI(url: string) {
    // Custom sanitization performed over url to avoid chars like '(', ')' or "'" that do not show if included
    //  in a background-image: url(...) CSS style
    const clearChars = ["'", '(', ')'];

    return clearChars.reduce(
        (cleanUrl, replaceChar) =>
            cleanUrl.replace(new RegExp(`\\${replaceChar}`, 'g'), `%${replaceChar.charCodeAt(0).toString(16)}`),
        url || '',
    );
}
